import { atom } from 'jotai'
import { TCountries, TCountry } from '../types'

// ✅ แนะนำ: ใช้ atom() สำหรับ package core
export const countriesAtom = atom<TCountries | null>(null)
export const selectedCountryAtom = atom<TCountry | null>(null)
export const isLoadingCountriesAtom = atom<boolean>(false)

// Derived atoms (computed values)
export const ushopCountriesAtom = atom(get => {
    const countries = get(countriesAtom)
    return countries?.data?.ushop || []
})

export const expressCountriesAtom = atom(get => {
    const countries = get(countriesAtom)
    return countries?.data?.express || []
})

export const feelgreatCountriesAtom = atom(get => {
    const countries = get(countriesAtom)
    return countries?.data?.feelgreat || []
})

// Write atoms (actions)
export const setCountriesAtom = atom(null, (get, set, countries: TCountries) => {
    set(countriesAtom, countries)
    set(isLoadingCountriesAtom, false)
})

export const setLoadingAtom = atom(null, (get, set, loading: boolean) => {
    set(isLoadingCountriesAtom, loading)
})

export const selectCountryAtom = atom(null, (get, set, country: TCountry) => {
    set(selectedCountryAtom, country)
})
